export const logoutEmployee = async () => {
    localStorage.removeItem('mobile_bearer');
    localStorage.removeItem('employee_bearer');
    localStorage.removeItem('employee_refresh_token');
    localStorage.removeItem('old_bearer');
    localStorage.removeItem('old_refresh_token');

};